import api from "../../../../services/api";

const BASE_URL = "/api/v1/resume-repository";

const normalizeResponse = (response) => response?.data ?? response;
const stripEmptyParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (Array.isArray(value)) return value.length > 0;
      return true;
    }),
  );

const resumeRepositoryService = {
  uploadResume: async (formData) => {
    const response = await api.post(`${BASE_URL}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return normalizeResponse(response);
  },

  bulkUploadResumes: async (formData) => {
    const response = await api.post(`${BASE_URL}/bulk-upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return normalizeResponse(response);
  },

  searchResumes: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/search`, {
      params: stripEmptyParams(params),
    });
    return normalizeResponse(response);
  },

  getResume: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return normalizeResponse(response);
  },

  downloadResume: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}/download`, {
      responseType: "blob",
    });
    return response;
  },

  getVersionTimeline: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}/versions`);
    return normalizeResponse(response);
  },

  mergeDuplicates: async (id, payload) => {
    const response = await api.post(
      `${BASE_URL}/${id}/merge-duplicates`,
      payload,
    );
    return normalizeResponse(response);
  },

  createApplicationFromRepository: async (candidateId, payload) => {
    const response = await api.post(
      `${BASE_URL}/${candidateId}/create-application`,
      payload,
    );
    return normalizeResponse(response);
  },

  createTalentPool: async (payload) => {
    const response = await api.post(`${BASE_URL}/talent-pools`, payload);
    return normalizeResponse(response);
  },

  listTalentPools: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/talent-pools`, { params });
    return normalizeResponse(response);
  },

  addCandidatesToPool: async (poolId, payload) => {
    const response = await api.post(
      `${BASE_URL}/talent-pools/${poolId}/candidates`,
      payload,
    );
    return normalizeResponse(response);
  },

  removeCandidatesFromPool: async (poolId, payload) => {
    const response = await api.delete(
      `${BASE_URL}/talent-pools/${poolId}/candidates`,
      {
        data: payload,
      },
    );
    return normalizeResponse(response);
  },

  matchByJob: async (jobId, params = {}) => {
    const response = await api.post(`${BASE_URL}/match/${jobId}`, null, {
      params,
    });
    return normalizeResponse(response);
  },
};

export default resumeRepositoryService;
